import { render } from "./EmptyContainer.vue?vue&type=template&id=1cd90b39&scoped=true&ts=true"
import script from "./EmptyContainer.vue?vue&type=script&lang=ts"
export * from "./EmptyContainer.vue?vue&type=script&lang=ts"

import "./EmptyContainer.vue?vue&type=style&index=0&id=1cd90b39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd90b39"]])

export default __exports__